<div
  *ngIf="alertMessage"
  class="alert-top"
  [class.alert-hidden]="scrolledAlertElement.scrolled"
  scrolledHeader
  #scrolledAlertElement="scrolledHeader"
>
  {{ alertMessage }}
</div>
<nav
  class="navbar navbar-expand-md navbar-dark bg-primary fixed-top"
  [class.navbar-scrolled]="
    scrolledHeaderElement.scrolled || !needAnimatonOnScroll
  "
  [class.has-alert]="alertMessage"
  scrolledHeader
  #scrolledHeaderElement="scrolledHeader"
  *ngIf="headerItems"
>
  <button
    class="navbar-toggler hidden-sm-up"
    type="button"
    (click)="isNavbarCollapsed = !isNavbarCollapsed"
    data-target="#navbarsDefault"
    aria-controls="navbarsDefault"
    aria-expanded="false"
    aria-label="Toggle navigation"
  >
    <i class="fas fa-bars"></i>
  </button>
  <div
    [class.show]="isNavbarCollapsed"
    class="collapse navbar-collapse"
    id="navbarsDefault"
  >
    <ul
      class="navbar-nav text-center"
      [class.mr-auto]="logoPlace === 'left'"
      [class.m-auto]="logoPlace === 'center'"
    >
      <li *ngIf="logoPlace === 'left'">
        <div class="navbar-brand mx-4">
          <img [src]="logoPath" /> {{ title }}
        </div>
      </li>
      <ng-container *ngFor="let item of headerItems; let i = index">
        <li
          class="text-center"
          *ngIf="logoPlace === 'center' && headerItems.length / 2 === i"
        >
          <div class="navbar-brand mx-4">
            <img [src]="logoPath" />
          </div>
        </li>
        <li
          *ngIf="!item.children"
          (click)="navBarClicked()"
          class="nav-item mx-3"
          routerLinkActive="active"
        >
          <a
            class="nav-link"
            title="{{ item.text }}"
            routerLink="/{{ item.route }}"
            >{{ item.text }}</a
          >
        </li>
        <li
          *ngIf="item.children"
          class="nav-item dropdown"
          appDropDown
          routerLinkActive="active"
        >
          <span title="{{ item.text }}" class="nav-link dropdown-toggle"
            >{{ item.text }}
          </span>
          <div class="dropdown-menu mt-0">
            <ng-container *ngFor="let child of item.children">
              <a
                *ngIf="child.route"
                (click)="navBarClicked()"
                class="dropdown-item"
                routerLink="/{{ child.route }}"
                routerLinkActive="active"
                title="{{ child.text }}"
                >{{ child.text }}</a
              >
              <button
                (click)="openLink(child.link)"
                *ngIf="child.link"
                class="dropdown-item"
                title="{{ child.text }}"
              >
                {{ child.text }}
              </button>
            </ng-container>
          </div>
        </li>
      </ng-container>
    </ul>
  </div>
</nav>
